<div class="tab-content">

    <div class="zone-form-content" style="margin-left: 10px;">
        <h1 style="font-weight: 800;">{{'DEFINED_CONTAINER'|translate}}</h1>

        <div class="content-card p-20 my-20">
            <mat-table class="zone-form-table" style="border-radius: 10px 10px 0px 0px;" #table
                [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" fusePerfectScrollbar>

                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CONTAINER'|translate}} {{'NAME'|translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let polygon">
                        {{polygon.container.name?polygon.container.name:'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="deviceId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE'|translate}} {{'ID'|translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let polygon">
                        {{polygon.container.deviceId?polygon.container.deviceId:'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="neighbor">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NEIGHBOURHOOD'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let polygon">
                        {{polygon.container.neighbor?polygon.container.neighbor:'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="street">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STREET'|translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let polygon">
                        {{(polygon.discriminator=="garbage-center")?(polygon.container.streetDesc?polygon.container.streetDesc:'---'):(polygon.container.street?polygon.container.street:'---')}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="site">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'SITE'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let polygon">
                        {{polygon.container.latitude?polygon.container.latitude:'---'}}
                        /
                        {{polygon.container.longitude?polygon.container.longitude:'---'}}
                    </mat-cell>
                </ng-container>

                <!-- setting Column -->
                <ng-container matColumnDef="setting">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'SETTINGS'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let polygon">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>settings</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="deletePolygonDetail(polygon)">
                                <mat-icon>delete</mat-icon>
                                <span>{{'DELETE'|translate}}</span>
                            </button>
                        </mat-menu>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let polygon; columns: displayedColumns;" class="order" matRipple>
                </mat-row>
            </mat-table>
            <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>